import { useTypedSelector } from "../../../hooks/useTypedSelector";
import { MusicService } from "../../../services/MusicService";
import { useActions } from "../../../hooks/useActions";
import './BattleMenu.css';
import StorageHelper from "../../../services/StorageHelper";

function MusicBattleButton(){
    const {music} = useTypedSelector(state => state.auth);
    const {setMusic} = useActions();

    let musicImageClass = ' battleMusicImageON';

    if(music.playBattle === false){
        musicImageClass = ' battleMusicImageOFF';
    }

    const OnOfMusic = function(){

        if(music.playBattle === true){
            music.playBattle = false;
            MusicService.stopBattle();
            
        }else{
            music.playBattle = true;
            MusicService.playBattleMusic();
        }
        StorageHelper.set('playBattle', music.playBattle);
        setMusic(music);
    };



    return (
        <div className={"musicButton" + musicImageClass} title="On\Off Music" onClick={() => { OnOfMusic();}}>

        </div>
    );
}

export default MusicBattleButton;